$(document).ready(() => {
  const $tabs = $('.store-listing-header .store-listing-header-inner .tabs-wrap ul li');
  const $tabContent = $('.store-listing-tab-content');

  $tabs.on('click', function() {
    const tabId = $(this).attr('data-tab');

    // Remove the default classes
    $tabs.removeClass('current');
    $tabContent.removeClass('current');

    // Add new classes on mouse click
    $(this).addClass('current');
    $(`#${tabId}`).addClass('current');
  });
  
  let location = $('.store-listing-dropdown select[name="country"]').val();
  $('.store-list-item').removeClass('hidden');
  if(location == ''){
    $('.store-list-item').removeClass('hidden');
  }else{
    $('.store-list-item:not(.'+location+')').addClass('hidden');
  }
  
  $(document).on('change','.store-listing-dropdown select[name="country"]',function(){
    let location = $(this).val();
    $('.store-list-item').removeClass('hidden');
    if(location == ''){
      $('.store-list-item').removeClass('hidden');
    }else{
      $('.store-list-item:not(.'+location+')').addClass('hidden');
    }
  });
});